<template>
	<div>
		<div style="width: 1000px;text-align: left;" class="center_sun">
			<br /><br /><br />
			<div v-show="this.$i18n.locale == 'zh'" v-html="data.text"></div>
			<div v-show="this.$i18n.locale == 'en'" v-html="data.text1"></div>
			
			<hr style="margin-bottom: 50px;"/>
			
			<div style="color: white;">	
				<h2>{{ $t('lang.News1')}}</h2>
				<div v-show="this.$i18n.locale == 'zh'" >
					<ul v-for="item in more" :key = "item.id">
						<div v-on:click='handle1(item.id)'>
							<li  style="width: 400px; float: left;margin:10px 40px 10px; " class="oneline">
								<i style="color: #b66a1b;">{{item.title}}</i>
							</li>
						</div>
					</ul>
				</div>
				<div v-show="this.$i18n.locale == 'en'" >
					<ul v-for="item in more" :key = "item.id">
						<div v-on:click='handle1(item.id)'>
							<li style="width: 400px; float: left;margin:10px 40px 10px;" class="oneline">
								<i style="color: #b66a1b;">{{item.titleEn}}</i>
							</li>
						</div>
					</ul>
				</div>
			</div>
			
			<div style="clear: both;"></div>
			
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data : "",
			more : "",
		};
	},
	created() {
		this.handle();
		this.morenews();
	},
	methods:{
		handle : function(){
			// console.log(this.$route.query.id);
			var id = this.$route.query.id
			var url = this.baseUrl+"news/find_news";
			this.axios({
				// 默认请求方式为get
				method: 'get',
				url: url,
				// 传递参数
				params: {
					id : id,
				},
			}).then(response => {
				// 请求成功
				// console.log(JSON.stringify(response.data));
				var megs = response.data.data;
				this.data = megs;
				// this.$ssrContext.title = megs.title+megs.titleEn;
				// this.$ssrContext.keywords = megs.title+megs.titleEn;
				// this.$ssrContext.description = megs.content+megs.contentEn;
				// document.getElementById("title").innerHTML = megs.title+megs.titleEn;
				// document.getElementById("keywords").content = megs.title+megs.titleEn;
				// document.getElementById("description").content = megs.content+megs.contentEn;
			}).catch(error => {
				// 请求失败，当then种出错就进入这里
				// console.log("请求失败"+JSON.stringify(error));
				error.constructor;
			});
		},
		morenews : function(){
			var url = this.baseUrl+"news/find_random_news";
			this.axios({
				// 默认请求方式为get
				method: 'get',
				url: url,
			}).then(response => {
				// 请求成功
				// console.log(JSON.stringify(response.data));
				this.more = response.data.data;
			}).catch(error => {
				// 请求失败，当then种出错就进入这里
				//console.log("请求失败"+JSON.stringify(error));
				error.constructor;
				
			});
		},
		handle1:function(id){
			//<router-link :to="{ path: 'dynamic_details', query: { item: {item}}}">
			
			let {href} = this.$router.resolve({ path: 'dynamic_details', query: { id: id }});
			window.open(href, '_blank')
		},
		
	},
	
}
</script>

<style scoped>
	div{
		color: white;
	}
</style>
